import fetch from '../utils/fetch'

// 统一配置（SMTP + 告警）
export function getEmailCommon () {
  return fetch({ url: '/espier/setting/email/common', method: 'get' })
}

export function setEmailCommon (data) {
  return fetch({ url: '/espier/setting/email/common', method: 'post', data })
}

// 类型配置
export function getEmailType (type) {
  return fetch({ url: `/espier/setting/email/type/${type}`, method: 'get' })
}

export function setEmailType (type, data) {
  return fetch({ url: `/espier/setting/email/type/${type}`, method: 'post', data })
}

// 发送记录
export function getEmailRecordList (params) {
  return fetch({ url: '/espier/email/record/list', method: 'get', params })
}

export function getEmailRecordDetail (id) {
  return fetch({ url: `/espier/email/record/${id}`, method: 'get' })
}

export function retryEmailRecord (id) {
  return fetch({ url: `/espier/email/record/${id}/retry`, method: 'post' })
}

export function resendEmailRecord (id) {
  return fetch({ url: `/espier/email/record/${id}/resend`, method: 'post' })
}
